<template>
  <div>
    <el-card class="myauth-card">
      <el-alert
        title=" 授权信息"
        type="warning"
        description=" KEY 请妥善保管，一旦泄露，请立即使用『重置』按钮重置"
        show-icon
        :closable='false'
      >
      </el-alert>
      <el-row :gutter="20" style="line-height: 40px; margin: 20px 0">
        <el-col :span="2">
          <span class="title">
             serviceID
          </span>
        </el-col>
        <el-col :span="8">
          <el-input readonly :value="serviceId"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="line-height: 40px; margin: 20px 0">
        <el-col :span="2">
          <span class="title">
              serviceKey
          </span>
        </el-col>
        <el-col :span="8">
          <el-input readonly="readonly" :value="serviceKey"></el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click.native="reset" :loading="loading">重置</el-button>
        </el-col>
        <!-- <el-col :span="6">
          <el-tag class="apiurl" type="gray">请求地址：http://cloud.takefit.cn/api/v1</el-tag>
        </el-col> -->
      </el-row>
    </el-card>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { post } from '@/utils/http'
  export default {
    data() {
      return {
        serviceKey: '',
        loading: false,
      }
    },
    computed: {
      ...mapState(['unit_id']),
      serviceId() {
        const temp = '00000000' + this.unit_id
        return temp.substr(-8)
      }
    },
    mounted() {
      this.getServiceKey()
    },
    methods: {
      async getServiceKey() {
        try {
          const res = await post('/unit/Index/getUnitServiceKey', {})
          if (res && res.rst == 0) {
            this.serviceKey = res.data.service_key
          }
        } catch(err) {

        }
      },
      reset() {
        this.$confirm('serviceKey重置后无法恢复, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const res = await post('/unit/Index/resetUnitServiceKey', {})
            if (res && res.rst == 0) {
              this.$message({
                message: '重置成功',
                type: 'success'
              })
              this.serviceKey = res.data.service_key
            }
          } catch(err) {

          }
        })
      }
    },
    name: 'myauth'
  }
</script>
<style lang="less" scoped>
  .myauth-card {
    widows: 100%;
  }
</style>
